module.exports = __webpack_public_path__ + "img/sign_count_gray.531df78a.svg";